// Scrolltrigger animation

gsap.registerPlugin(ScrollTrigger);
gsap.config({ nullTargetWarn: false, });


// 背景固定パララックス
let getRatio = el => window.innerHeight / (window.innerHeight + el.offsetHeight);

gsap.utils.toArray(".palaWrap").forEach((section, i) => {
  section.bg = section.querySelector(".bg"); 

  gsap.fromTo(section.bg, {
    backgroundPosition: () => i ? `50% ${-window.innerHeight * getRatio(section)}px` : "50% 0px"
  }, {
    backgroundPosition: () => `50% ${window.innerHeight * (1 - getRatio(section))}px`,
    ease: "none",
    scrollTrigger: {
      trigger: section,
      start: () => i ? "top bottom" : "top top", 
      end: "bottom top",
      scrub: true,
      invalidateOnRefresh: true // to make it responsive
    }
  });
});


// フェードイン
gsap.utils.toArray(".js_fadein").forEach(target => {
  gsap.fromTo(target, {
    autoAlpha: 0,
  }, {
    autoAlpha: 1,
    scrollTrigger: {
      trigger: target,
      start: "top 70%",
      toggleActions: "play none none reset",
    },
  });
});

// フェードイン 遅め
gsap.utils.toArray(".js_fadein_slow").forEach(target => {
  gsap.fromTo(target, 1.0, {
    autoAlpha: 0,
  }, {
    autoAlpha: 1,
    scrollTrigger: {
      trigger: target,
      start: "top 70%",
      toggleActions: "play none none reset",
    },
  });
});

// フェードイン 遅め・一度だけ
gsap.utils.toArray(".js_fadein_once").forEach(target => {
  gsap.fromTo(target, 1.0, {
    autoAlpha: 0,
  }, {
    autoAlpha: 1,
    scrollTrigger: {
      trigger: target,
      start: "top 80%",
    },
  });
});


// フェードアップ
gsap.utils.toArray(".js_up").forEach(target => {
  gsap.fromTo(target, {
    autoAlpha: 0,
	y: 50,
  }, {
    autoAlpha: 1,
	y: 0,
    scrollTrigger: {
      trigger: target,
      start: "top 70%",
      toggleActions: "play none none reset",
    },
  });
});


// フェードダウン
gsap.utils.toArray(".js_down").forEach(target => {
  gsap.fromTo(target, {
    autoAlpha: 0,
	y: -50,
  }, {
    autoAlpha: 1,
	y: 0,
    scrollTrigger: {
      trigger: target,
      start: "top 70%",
      toggleActions: "play none none reset",
    },
  });
});


// 左から右へフェードイン
gsap.utils.toArray(".js_left").forEach(target => {
  gsap.fromTo(target, {
    autoAlpha: 0,
	x: -50,
  }, {
    autoAlpha: 1,
	x: 0,
    scrollTrigger: {
      trigger: target,
      start: "top 70%",
      toggleActions: "play none none reset",
    },
  });
});

// 右から左へフェードイン
gsap.utils.toArray(".js_right").forEach(target => {
  gsap.fromTo(target, {
    autoAlpha: 0,
	x: 50,
  }, {
    autoAlpha: 1,
	x: 0,
    scrollTrigger: {
      trigger: target,
      start: "top 70%",
      toggleActions: "play none none reset",
    },
  });
});



// ULの子要素がそれぞれターゲットエリアに入った時にフェードアップ
const list = gsap.utils.toArray(".js_listfade02");
list.forEach((list) => {
  gsap.from(list.children, {
	y: 50,
	opacity: 0,
	scrollTrigger: {
		trigger: list,
		start: 'top 70%',
		toggleActions: "play none none reset",
	},
	stagger: {
		from: "start", //左からアニメーション start、center、edges、random、endが指定できる
		each: 0.2
	}
  });
});




// batch:
// 同じclassが付いているものを時差を付けてフェードイン
gsap.set(".batch_fade", {autoAlpha: 0});
batch(".batch_fade", {
  interval: 0.7,
  batchMax: 4,
  onEnter: batch => gsap.to(batch, {autoAlpha: 1, stagger: 0.05, overwrite: true}),
  onLeave: batch => gsap.set(batch, {autoAlpha: 1, overwrite: true}),
  onEnterBack: batch => gsap.to(batch, {autoAlpha: 1, stagger: 0.05, overwrite: true}),
  onLeaveBack: batch => gsap.set(batch, {autoAlpha: 1, overwrite: true})
});
// 同じclassが付いているものを時差を付けてフェードアップ
gsap.set(".batch_fadeup", {autoAlpha: 0, y: 100});
batch(".batch_fadeup", {
  interval: 0.1,
  batchMax: 3,
  onEnter: batch => gsap.to(batch, {autoAlpha: 1, y: 0, stagger: 0.05, overwrite: true}),
  onLeave: batch => gsap.set(batch, {autoAlpha: 1, y: 0, overwrite: true}),
  onEnterBack: batch => gsap.to(batch, {autoAlpha: 1, y: 0, stagger: 0.05, overwrite: true}),
  onLeaveBack: batch => gsap.set(batch, {autoAlpha: 1, y: 0, overwrite: true})
});


function batch(targets, vars) {
  let varsCopy = {},
      interval = vars.interval || 0.1,
      proxyCallback = (type, callback) => {
        let batch = [],
            delay = gsap.delayedCall(interval, () => {callback(batch); batch.length = 0;}).pause();
        return self => {
          batch.length || delay.restart(true);
          batch.push(self.trigger);
          vars.batchMax && vars.batchMax <= batch.length && delay.progress(1);
        };
      },
      p;
  for (p in vars) {
    varsCopy[p] = (~p.indexOf("Enter") || ~p.indexOf("Leave")) ? proxyCallback(p, vars[p]) : vars[p];
  }
  gsap.utils.toArray(targets).forEach(target => {
    let config = {};
    for (p in varsCopy) {
      config[p] = varsCopy[p];
    }
    config.trigger = target;
    ScrollTrigger.create(config);
  });
}